import { DOCUMENT } from '@angular/common';
import { Injectable, Renderer2, inject } from '@angular/core';
import { getQueryParam } from '../helpers/url.helper';

interface ITheme {
	name: string;
	baseColor?: string;
	isActive?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
	private document = inject<Document>(DOCUMENT);

	public themes: ITheme[] = [
		{
			name: 'light',
			baseColor: '#2b0d61',
			isActive: true
		}
	];
	public activatedTheme: ITheme = {name: ''};

	// Invoked in AppComponent and apply 'activatedTheme' on startup
	applyMatTheme(r: Renderer2) {
		this.activatedTheme = this.themes[0];

		// *********** ONLY FOR DEMO **********
		this.setThemeFromQuery();
		// ************************************

		this.changeTheme(r, this.activatedTheme);
	}

	changeTheme(r: Renderer2, theme: ITheme) {
		const root = this.document.documentElement;
		r.removeClass(root, this.activatedTheme.name);
		r.addClass(root, theme.name);
		this.flipActiveFlag(theme);
	}
	flipActiveFlag(theme: ITheme) {
		this.themes.forEach(t => {
			t.isActive = false;
			if (t.name === theme.name) {
				t.isActive = true;
				this.activatedTheme = theme;
			}
		});
	}

	// *********** ONLY FOR DEMO **********
	setThemeFromQuery() {
		const themeStr = getQueryParam('theme');
		try {
			this.activatedTheme = JSON.parse(themeStr);
			this.flipActiveFlag(this.activatedTheme);
		} catch (e) { }
	}
}
